import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { CreditPackage } from "./types";
import { GlobalState } from "../store";

export type CreditPackageSelectedState = {
  id: number | null;
  amount: number | null;
  isCustom: boolean;
  serviceFee: number;
  eventCode?: string | null;
  className?: string | null;
  ticketTypeCode?: string | null;
  priceCode?: string | null;
  seatCount?: number | null;
  sectionName?: string | null;
  accountGroupId?: number | null;
  accountGroupName?: string | null;
  title?: string | null;
} | null;

interface PurchaseCreditCart {
  amount: number;
  cartId: number;
  paymentToken: string;
  sessionId: string;
}

const initialState: {
  creditPackages: CreditPackage[];
  selected: CreditPackageSelectedState;
  purchaseCreditCartState?: PurchaseCreditCart;
} = {
  creditPackages: [],
  selected: null,
};

export const purchaseCreditState = createSlice({
  name: "purchaseCredit",
  initialState,
  reducers: {
    setCreditPackages: (
      state,
      action: PayloadAction<{
        packages: CreditPackage[];
        sortBy: "amount" | "mostExpensive";
      }>
    ) => {
      state.creditPackages = action.payload.packages.sort((a, b) =>
        action.payload.sortBy === "amount"
          ? a.amount - b.amount
          : b.amount - a.amount
      );
    },
    setCreditPackageSelected: (
      state,
      action: PayloadAction<(typeof initialState)["selected"]>
    ) => {
      state.selected = action.payload;
    },
    setPurchaseCreditCart: (
      state,
      action: PayloadAction<PurchaseCreditCart>
    ) => {
      state.purchaseCreditCartState = action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseCredit;

export const selectCreditPackagesByDue = (dueAmount: number) =>
  createSelector(selector, (s) => {
    return s.creditPackages
      .filter((itm) => itm.amount >= dueAmount)
      .sort((a, b) => {
        return a.amount < b.amount ? -1 : 1;
      });
  });

export const selectCreditPackages = createSelector(selector, (s) => {
  return s.creditPackages;
});

export const selectCreditPackageSelected = createSelector(selector, (s) => {
  return s.selected;
});

export const purchaseCreditCart = createSelector(
  selector,
  (s) => s.purchaseCreditCartState
);

export const {
  setCreditPackages,
  setCreditPackageSelected,
  setPurchaseCreditCart,
} = purchaseCreditState.actions;
export default purchaseCreditState.reducer;
